/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSWITCHINTYPE = {
    Percentage: 'P'
} as const;
export type IAPSWITCHINTYPE = typeof IAPSWITCHINTYPE[keyof typeof IAPSWITCHINTYPE];


export function IAPSWITCHINTYPEFromJSON(json: any): IAPSWITCHINTYPE {
    return IAPSWITCHINTYPEFromJSONTyped(json, false);
}

export function IAPSWITCHINTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSWITCHINTYPE {
    return json as IAPSWITCHINTYPE;
}

export function IAPSWITCHINTYPEToJSON(value?: IAPSWITCHINTYPE | null): any {
    return value as any;
}

